export default __webpack_public_path__ + "static/media/Hadoop.09301120.png";